import { useGeolocationContext } from 'providers/GeolocationProvider';
import { formatNumber } from 'utils/numbers';
import { Icons } from '../common/icons/Icon';
import LocationSearchResult from './LocationSearchResult';

type CurrentLocationProps = {
  onSelect?: () => any;
};

function CurrentLocation({ onSelect }: CurrentLocationProps) {
  const { position } = useGeolocationContext();

  if (position) {
    const lat = Number(formatNumber(position.coords.latitude, { maximumFractionDigits: 2 }));
    const lon = Number(formatNumber(position.coords.longitude, { maximumFractionDigits: 2 }));

    return (
      <LocationSearchResult
        iconName={Icons.LocationDot}
        location={{
          name: 'Current Location',
          region: '',
          country: '',
          lat: lat,
          lon: lon,
        }}
        onSelect={onSelect}
        testid="current-location"
      />
    );
  }

  return null;
}

export default CurrentLocation;
